import { createElement } from "react";
import SamiSpin from "components/SamiSpin";

/* The suite loader — Sami's mark, working. See LoadingComponent for why the
   lucide ring stays on as the pre-upgrade fallback child.

   Props:
   - label: optional text shown by the loader element
   - size:  loader size in px (default 44)
   - bare:  render just the <semi360-loader> element, no centering wrapper
   - className: extra classes on the wrapper (ignored when bare) */
const Spinner = ({ label, size = 44, bare = false, className = "" }) => {
  const loader = createElement(
    "semi360-loader",
    { ...(label ? { label } : {}), size: String(size) },
    <SamiSpin className="animate-spin text-s360-violet" size={Math.min(32, size)} />,
  );

  if (bare) return loader;

  return (
    <div className={`flex flex-col items-center justify-center h-full ${className}`}>
      {loader}
    </div>
  );
};

export default Spinner;
